import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faStar } from '@fortawesome/pro-solid-svg-icons';

import ScheduleModal from './modal';
import TiersTable from './tiers_table';
import Tooltip from 'components/tooltip';
import { USD } from 'helpers/formatters/number_formats';
import { formatDate } from 'helpers/formatters/date_time_formats';

export function ScheduleRow({ isParentCompanyUser, royaltySchedule }) {
  const [showModal, setShowModal] = useState();

  const tiersTable = <TiersTable royaltySchedule={royaltySchedule} />;
  const getCurrentTierPercentage = (royaltySchedule) => {
    const ytd = royaltySchedule.filedCommissionAmountYearToDate;
    const currentTier = royaltySchedule.tiers.find(
      tier => ytd >= tier.from && (tier.to === null || ytd < tier.to)
    );
    return currentTier ? `${currentTier.royaltyPercentage}%` : '';
  };

  return (
    <tr>
      {isParentCompanyUser && <>
        <td>
          {royaltySchedule.name || '--'}
          {royaltySchedule.companyDefault && (
            <Tooltip content="Company Default" dark>
              <FontAwesomeIcon className="text-primary" fixedWidth icon={faStar} size="sm" />
            </Tooltip>
          )}
        </td>
        <td>
          <Tooltip content={tiersTable} rootClose trigger="click">
            <span className="text-primary clickable">{royaltySchedule.royaltyPatternLabel}</span>
          </Tooltip>
        </td>
      </>}

      <td className="text-center">
        <Tooltip content={tiersTable} rootClose trigger="click">
          <span className="text-primary clickable">{royaltySchedule.tiers.length}</span>
        </Tooltip>
      </td>

      <td className="text-center">{royaltySchedule.numberOfAgents}</td>
      <td className="text-center">{royaltySchedule.numberOfAgentsPaid}</td>
      <td className="text-end">{USD.format(royaltySchedule.filedCommissionAmountYearToDate)}</td>
      <td className="text-end">{getCurrentTierPercentage(royaltySchedule)}</td>

      {isParentCompanyUser && <>
        <td className="text-center">{formatDate(royaltySchedule.updatedAt)}</td>
        <td style={{ width: 0 }}>
          <a className="clickable text-nowrap" name="show-modal-link" onClick={() => setShowModal(true)}>
            <FontAwesomeIcon fixedWidth icon={faEdit} /> Edit
          </a>
          <ScheduleModal
            royaltySchedule={royaltySchedule}
            show={showModal}
            onClose={() => setShowModal(false)}
          />
        </td>
      </>}
    </tr>
  );
}

ScheduleRow.propTypes = {
  isParentCompanyUser: PropTypes.bool,
  royaltySchedule: PropTypes.shape({
    companyDefault: PropTypes.bool,
    filedCommissionAmountYearToDate: PropTypes.number,
    name: PropTypes.string,
    numberOfAgents: PropTypes.number,
    numberOfAgentsPaid: PropTypes.number,
    royaltyPatternLabel: PropTypes.string,
    tiers: PropTypes.array,
    updatedAt: PropTypes.string,
  }).isRequired,
};

export default ScheduleRow;
